import {
  ADDITIONAL_OPTION_MAP,
  BASIC_OPTION_MAP,
  POPULAR_OPTION_MAP,
  PROPERTY_TYPE_MAP,
  PYEONG_SIZE_MAP,
  ROOM_COUNT_MAP,
  ROOM_DISCOUNT_MAP,
  type TSearchFilter,
} from '@/entities/map'

type SearchEventFilters = Pick<
  TSearchFilter,
  | 'roomCounts'
  | 'propertyTypes'
  | 'pyeongSizes'
  | 'popularOptions'
  | 'basicOptions'
  | 'additionalOptions'
  | 'roomDiscounts'
>

const env = process.env.NEXT_PUBLIC_ENVIRONMENT
const place = env === 'local' || !env ? 'test' : env

export const buildSearchSemanticAttributes = (filters: SearchEventFilters) => {
  const transactionPairedEventCategory = filters.roomCounts
    .map(roomCount => ROOM_COUNT_MAP[roomCount])
    .join(', ')

  const transactionType = filters.pyeongSizes
    .map(pyeongSize => PYEONG_SIZE_MAP[pyeongSize])
    .join(', ')

  const categoryName = filters.propertyTypes
    .map(propertyType => PROPERTY_TYPE_MAP[propertyType])
    .join(', ')

  const description = [
    ...filters.popularOptions.map(option => POPULAR_OPTION_MAP[option]),
    ...filters.basicOptions.map(option => BASIC_OPTION_MAP[option]),
    ...filters.additionalOptions.map(option => ADDITIONAL_OPTION_MAP[option]),
  ].join(', ')

  const type = filters.roomDiscounts
    .map(roomDiscount => ROOM_DISCOUNT_MAP[roomDiscount])
    .join(', ')

  return {
    transactionPairedEventCategory,
    transactionType,
    products: categoryName ? [{ categoryName }] : [],
    description,
    type,
    place,
  }
}
